<template functional>
    <div class="tile-content tile-content-secondary">Churn the subscription.</div>
</template>

<script>
    export default {
        name: 'churn-subscription',
    };
</script>
